module.exports = __webpack_public_path__ + "media/images/flags/32/Norfolk-Island-167da269415a11d68518daf80cac54d5.png";